<template>
  <div>
    <el-row :gutter="20">
      <el-col :md="10" :sm="24" v-if="!read_only">
        <el-card class="box-card">
          <div slot="header" class="text-center">
            Registro de Vacaciones
          </div>
          <el-form ref="form"
                   label-position="top"
                   :model="form"
                   label-width="120px"
                   :rules="rules">
            <el-row :gutter="10">
              <el-col :md="12">
                <el-form-item label="Fecha de Inicio" prop="date">
                  <el-date-picker type="date"
                                  v-model="form.date"
                                  placeholder="Seleccione una fecha"
                                  style="width: 100%;"
                                  format="dd-MM-yyyy"
                                  value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="Nivel" prop="level_id">
                  <el-select v-model="form.level_id" placeholder="Seleccionar"  style="width: 100%;">
                    <el-option
                      v-for="item in levels"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                      <span style="float: left">{{ item.name }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="24">
                <el-form-item label="Contratos" prop="contract_id">
                  <el-select v-model="form.contract_id" placeholder="Seleccionar"  style="width: 100%;">
                    <el-option
                      v-for="item in contracts"
                      :key="item.id"
                      :label="item.start_date +' - '+ item.end_date"
                      :value="item.id">
                      <span style="float: left">{{ item.start_date + " - "+ item.end_date }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item prop="is_deductible" label="¿Agregar Monto deducible?">
                  <el-switch
                    v-model="form.is_deductible"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Si"
                    @change="change()"
                    inactive-text="No">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :md="12" v-if="form.is_deductible">
                <el-form-item label="Razón del deducible" prop="deductible_type_id">
                  <el-select v-model="form.deductible_type_id" placeholder="Seleccionar"  style="width: 100%;">
                    <el-option
                      v-for="item in deductibletypes"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                      <span style="float: left">{{ item.name }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12" v-if="form.is_deductible">
                <el-form-item label="Monto total a deducir" prop="deductible">
                  <el-input-number v-model="form.deductible"
                                   :min="0"
                                   controls-position="right"
                                   style="width: 100%;"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :md="12" v-if="form.is_deductible">
                <el-form-item label="Monto a reducir p/periodo" prop="step">
                  <el-input-number v-model="form.step"
                                   :min="0"
                                   controls-position="right"
                                   style="width: 100%;"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :md="12" >
                <el-form-item label="Monto cancelado" prop="paid" v-if="form.is_deductible">
                  <el-input v-model="form.paid"
                                   style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>

              <el-col :md="24">
                <el-form-item prop="observation" label="Observación">
                  <el-input
                    type="textarea"
                    autosize
                    placeholder="Escriba una observación (opcional)"
                    v-model="form.observation">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <div role="alert" v-if="error.message" class="el-alert el-alert--error">
              <div class="el-alert__content">
                <span class="el-alert__title is-bold">{{ error.message }}</span>
                <p class="el-alert__description">
                <ul>
                  <li v-for="item in error.errors">{{ item[0] }}</li>
                </ul>
                </p>
              </div>
            </div>

            <el-button @click="clear()">
              Cancelar
            </el-button>

            <el-button type="primary"  style="margin-top: 20px" :loading="processing" @click="save()">
              <span v-if="!processing">Guardar</span>
              <span v-else>Procesando...</span>
            </el-button>
          </el-form>

        </el-card>
      </el-col>
      <el-col :md="read_only ? 24 : 14" :sm="read_only ? 24 : 14">
        <app-table
          @change-pagination="onChangePagination"
          @change-search="onChangeSearch"
          :total="total">
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="date"
              label="Fecha">
            </el-table-column>
            <el-table-column
              prop="observation"
              label="Descripción">
            </el-table-column>
            <el-table-column
              label="Contrato">
              <template slot-scope="scope">
                <p>{{ scope.row.contract.start_date + " - "}}
                  <span v-if="scope.row.contract.end_date == null">Indefinido</span>
                  <span v-else>{{scope.row.contract.end_date}}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column
              label="¿Deducible?">
              <template slot-scope="scope">
                <p>{{ (scope.row.is_deductible) ? "Si" : "No" }}</p>
              </template>
            </el-table-column>
            <el-table-column
              :width ="100"
              v-if="!read_only"
              label="">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="warning"
                  @click="showDialog(scope.row)"><i class="el-icon-edit"></i></el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"><i class="el-icon-delete"></i></el-button>
              </template>
            </el-table-column>
          </el-table>
        </app-table>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  import AppTable from '../../components/Table'
  import {baseApi} from '../../configs/urls'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {parseError} from '../../packages/Helpers'
  export default {
    extends: BaseCrud,
    name: 'form-list',
    props: ['employee_id', 'read_only'],
    components: {
      AppTable
    },
    data () {
      const validateStep = (rule, value, callback) => {
        if (value > this.form.deductible) {
          callback(new Error('El monto a reducir por periodo no puede ser mayor al monto total'))
        } else if (this.form.deductible % value !== 0) {
          callback(new Error('El monto a rebajar por periodo no es divisible con el monto total'))
        } else {
          callback()
        }
      }
      return {
        baseUrl: baseApi + '/incidents',
        loadingcontracts: false,
        contracts: [],
        levels: [],
        deductibletypes: [],
        form: {
          observation: '',
          employee_id: this.employee_id,
          user_id: this.$store.state.auth.id,
          is_deductible: false,
          deductible_type_id: 1,
          deductible: 0,
          step: 0
        },
        rules: {
          step: [{validator: validateStep, trigger: 'blur'}],
          init_date: [{ required: true, message: 'La Fecha de Inicio es requerida', trigger: 'blur' }],
          end_date: [{ required: true, message: 'La Fecha de Inicio es requerida', trigger: 'blur' }],
          cost_center_id: [{ required: true, message: 'El Centro de Costo es requerido', trigger: 'blur' }],
          payroll_id: [{ required: true, message: 'La Planilla es requerida', trigger: 'blur' }],
          position_id: [{ required: true, message: 'La Posición Laborar es requerida', trigger: 'blur' }],
          observation: [{ required: true, message: 'La observación es requerida', trigger: 'blur' }],
          salary: [
            { required: true, message: 'La Posición Laborar es requerida' }
          ]
        }
      }
    },
    watch: {
      employee_id (id) {
        console.log(id)
        this.clear()
        this.employee_id = id
        this.loadData()
        this.refreshData()
      }
    },
    methods: {
      loadData () {
        this.loadingcontracts = true
        this.$http.get(baseApi + '/contracts/getlist?employee_id=' + this.employee_id)
         .then(
           (response) => {
             this.contracts = response.body
             this.loadingcontracts = false
           },
           (res) => {
             this._notifyError(parseError(res)[0])
             this.loadingcontracts = false
           }
         )
        this.$http.get(baseApi + '/levels/getlist')
         .then(
           (response) => {
             this.levels = response.body
           },
           (res) => {
             this._notifyError(parseError(res)[0])
           }
         )
        this.$http.get(baseApi + '/deductibletypes/getlist')
         .then(
           (response) => {
             this.deductibletypes = response.body
           },
           (res) => {
             this._notifyError(parseError(res)[0])
           }
         )
      },
      _formatModel (model) {
        if (typeof (model.is_deductible) !== typeof (true)) {
          model.is_deductible = parseInt(model.is_deductible)
        }
        model.is_deductible = (model.is_deductible === 1 || model.is_deductible === true)
        model.contract_id = parseInt(model.contract_id)
        model.deductible_type_id = parseInt(model.deductible_type_id)
      },
      change () {
        console.log('is here')
        if (this.form.is_deductible) {
          this.form.deductible_type_id = 2
        } else {
          this.form.deductible_type_id = 1
          this.form.step = 0
          this.form.deductible = 0
          this.form.step = 0
          this.form.last_payment = '0000-00-00'
          this.form.paid = 0
        }
      },
      showDialog (model) {
        model.is_deductible = (model.is_deductible === 1) || (model.is_deductible)
        this.form.is_deductible = (this.form.is_deductible === 1) || this.form.is_deductible
        if (model) {
          this._formatModel(model)
          this.actionText = 'Actualizar'
          this.form = {...model}
        } else {
          this.dialogTitle = 'Nuevo'
          this.actionText = 'Agregar'
          if (this.form.id) {
            this.form = {}
            this.$refs.form.resetFields()
          }
        }

        this.dialogTitle = this._getDialogTitle(this.form)
        this.dialogVisible = true
      },
      _getDeleteTitle (model) {
        return 'Esta seguro que desea elimnar la vacación ' + model.init_date + ' ' + model.end_date
      },
      _beforeRefresh (query) {
        query.employee_id = this.employee_id
      },
      _notifyError (message) {
        this.$notify.error({
          title: 'Error',
          message: message
        })
      },
      _beforeSend (model) {
        model.employee_id = this.employee_id
        return model
      },
      _mounted () {
        this.loadAll()
        this.loadData()
      },
      clear () {
        this.form = {}
        this.$refs.form.resetFields()
      },
      loadAll () {
        this.refreshData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/employees/IncidentList.vue